import { z } from "zod";
const FormSectionSimpleSchema = z.object({
  id: z.string().optional().nullable(),
  formId: z.string(),
  successMessage: z.object({
    title: z.string(),
    description: z.string(),
    buttonText: z.string()
  }).optional().nullable()
});
export default FormSectionSimpleSchema;
